<template>
  <div class="app-center">
    <div class="top-bar">
      <div class="top-bar-img" />
    </div>
    <div
      v-for="item in cp_list"
      :key="item.appCategoryId"
      class="app-list"
    >
      <div class="appCategory">
        <div class="appCategory-name">
          {{ item.appCategoryName }}
        </div>
        <div class="line">
          <div class="left-line" />
          <div class="right-line" />
        </div>
      </div>
      <div
        v-for="itm in item.list"
        :key="itm.appId"
        class="app-item"
      >
        <div
          class="item"
          :title="itm.appName"
          @click="onClickItem(itm)"
        >
          <web-img
            width="80px"
            height="80px"
            :src="itm.icon"
            type="appIcon"
          />
          <div
            class="app-name"
          >
            {{ itm.appName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../proxy';
import webImg from '../components/webImg';
import { loginByUserToken, openUrl, downloadUrlFile } from '../../../../../lib/utils';
export default {
    name: 'AppCenter',
    components: { webImg },

    data () {
        return {
            appList: [],
            isClicked: false,
        };
    },
    computed: {
        cp_list () {
            const result = [];
            for (const item of this.appList) {
                let category = result.find(itm => itm.appCategoryId === item.appCategoryId);
                if (!category) {
                    category = {
                        appCategoryId: item.appCategoryId,
                        appCategoryName: item.appCategoryName,
                        list: [],
                    };
                    result.push(category);
                }
                category.list.push(item);
            }
            return result;
        },
        loginStatus () {
            return this.$store.getters['global/isLogin'];
        },
    },
    created () {
        this.initData();
    },
    methods: {
        async initData () {
            const res = await api.listByCondition();
            if (res.errcode === 0) {
                this.appList = res.data.list;
            } else {
                this.$message.error(res.errmsg);
            }
        },
        async onClickItem (itm) {
            if (itm.isClicked) return;
            itm.isClicked = true;
            setTimeout(() => {
                itm.isClicked = false;
            }, 5000);
            const param = {
                appId: itm.appId,
            };
            if (this.loginStatus) param.identityId = this.$store.getters['global/loginInfo'].identityId;
            const res = await api.clickApp(param);
            if (res.errcode === 0) {
                const data = res.data;
                if (itm.path) {
                    this.$router.push(itm.path);
                } else if (data.type === 0) { // 优学派web应用
                    if (!this.loginStatus) {
                        this.$message.error('请先登录');
                    } else {
                        let getters = this.$store.getters,
                            jwtRefresh = `userToken=${getters['global/loginInfo'].jwtRefresh}`,
                            firstLoginTime = `firstLoginTime=${getters['global/firstLoginTime']}`,
                            uuid = `uuid=${getters['global/currentOrg'].uuid}`,
                            equipmentId = `equipmentId=${getters['global/nav/equipmentId']}`,
                            param = `${jwtRefresh}&${uuid}&${equipmentId}&${firstLoginTime}`,
                            backUrl = `${itm.origin || location.origin}${itm.pathname || ''}${itm.hash || ''}`,
                            url;
                        // 班级空间、学习打卡、学情报告、使用新窗口打开
                        if ([75, 80, 82].includes(+itm.appId)) {
                            let pathname = itm.pathname;
                            pathname = pathname.lastIndexOf('/') ? pathname.slice(0, pathname.length - 1) : pathname;
                            url = `${itm.origin || location.origin}${pathname || ''}${itm.hash || ''}`;
                            url = url.includes('?') && `${url}&${param}` || `${url}?${param}`;
                            openUrl(url);
                            itm.isClicked = false;
                            return;
                        }
                        if (backUrl.includes('#/')) {
                            url = backUrl.includes('?') && `${backUrl}&${param}` || `${backUrl}?${param}`;
                        } else {
                            url = `${backUrl}#/?${param}`;
                        }
                        openUrl(url, '_self');
                    }
                } else if (data.type === 1) { // 优学派教师移动端
                    if (window.yxpapiConfig.env === 'production') {
                        // https://www.youxueketang.com/#/download/phone
                        openUrl(`https://www.youxueketang.com/#/download/phone`);
                    } else {
                        openUrl('https://proj002test.anoah.com/yxp-website/#/download/phone');
                    }
                } else if (data.type === 2) { // 第3方web应用
                    let obj = {};
                    let queryParams = itm.queryParams ? itm.queryParams.split('&') : [];
                    queryParams.forEach(v => {
                        let key = v.split('=')[0]; let val = v.split('=')[1];
                        obj[key] = val;
                    });
                    if (obj.appKey) {
                        if (!this.loginStatus) {
                            this.$message.error('请先登录');
                        } else {
                            const res = await api.getCodeByToken({
                                'authorization': this.$store.getters['global/loginInfo'].jwt, // 当前平台用户登录后的有效的token
                                'appKey': obj.appKey, // 必填, 当前应用的key值
                                'platformType': 'pc_web', // 必填, 平台类型，可选择参见公共说明
                                'orgId': this.$store.getters['global/loginInfo'].orgId, // 必填,当前机构的id
                            });
                            if (res.errcode === 0) {
                                const url = `${itm.origin}/?code=${res.data.code}&openOrgId=${res.data.openOrgId}`;
                                openUrl(url);
                            } else {
                                this.$message.error(res.errmsg);
                            }
                        }
                    } else {
                        const url = data.actionUrl;
                        openUrl(url);
                    }
                } else if (data.type === 3) { // 优学派和第3方pc客户端
                    const msg = this.$message.info({
                        message: '正在下载文件，请稍等',
                        duration: 10000,
                        showClose: true,
                    });
                    let ext = data.actionUrl.lastIndexOf('.');
                    if (ext > -1) {
                        ext = data.actionUrl.substr(ext, data.actionUrl.length);
                    } else {
                        ext = '';
                    }
                    const appName = data.appName + ext;
                    downloadUrlFile(data.actionUrl, appName, status => {
                        msg && msg.close();
                        itm.isClicked = false;
                    });
                    return;
                }
            } else if (res.errcode === 1) {
                this.$message.error('对不起，您暂时没有访问权限');
            } else if (res.errcode === 4013) { // token过期
                loginByUserToken(result => {
                    if (result) {
                        itm.isClicked = false;
                        this.onClickItem(itm);
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            } else {
                this.$message.error(res.errmsg);
            }
            itm.isClicked = false;
        },
    },
};
</script>

<style scoped lang="scss">
.app-center {
    box-sizing: border-box;
    @import "../style.scss";
    min-height: calc(100vh - 200px);
    .top-bar {
        width: 100%;
        height: 320px;
        background: linear-gradient(270deg, #4182E8 0%, #A7C3EF 100%);
        margin-bottom: 40px;
        .top-bar-img {
            width: 100%;
            height: 100%;
            background-image: url("../../../../../assets/image/app-bar.png");
            background-repeat: no-repeat;
            background-position: 60% bottom;
        }
    }
    .app-list {
        width: 1260px;
        margin:  0 auto;
        box-sizing: border-box;
        clear: both;
        overflow: hidden;
        .appCategory {
            width: $pageWidth - 8px;
            margin: 0 auto;
            padding-bottom: 8px;
            .appCategory-name {
                display: inline-block;
                color: #464C5B;
                font-size: 24px;
                padding-bottom: 6px;
                box-sizing: border-box;
            }
            .line {
                width: 100%;
                display: flex;
                .left-line {
                    width: 60px;
                    border-bottom: 2px solid #2873E9;
                }
                .right-line {
                    flex: auto;
                    border-bottom: 2px solid #E3E8EE;
                }
                margin-bottom: 30px;
            }
        }
        .app-item {
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 140px;
            margin-bottom: 40px;
            .item {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                cursor: pointer;
                .app-name {
                    display: inline-block;
                    color: #464C5B;
                    font-size: 16px;
                    max-width: 112px;
                    text-align: center;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
